module.exports = __webpack_public_path__ + "static/media/appointment-period-cancelled.5cfabe09.svg";